import { useEffect } from 'react';

const BODY_CLASS = 'rht-hide-pendo-launcher';

function dismissResourceCenter() {
  if (typeof window === 'undefined') return;
  window.pendo?.BuildingBlocks?.BuildingBlockResourceCenter?.dismissResourceCenter?.();
}

/**
 * Hides Pendo Resource Center badge when shouldHide is true.
 * Also closes the Resource Center pane if open via Pendo API.
 * Uses a body class + CSS (!important) so wrappers/iframes cannot steal clicks after the badge is hidden.
 * MutationObserver keeps dismissing the Resource Center when Pendo injects DOM asynchronously.
 */
export default function usePendoVisibility(shouldHide: boolean): void {
  useEffect(() => {
    if (!shouldHide) {
      document.body.classList.remove(BODY_CLASS);
      return;
    }

    dismissResourceCenter();
    document.body.classList.add(BODY_CLASS);

    const observer = new MutationObserver(() => {
      dismissResourceCenter();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // eslint-disable-next-line consistent-return
    return () => {
      observer.disconnect();
      document.body.classList.remove(BODY_CLASS);
    };
  }, [shouldHide]);
}
